/** Lib Imports */
import React, { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import PropTypes from 'prop-types';

/** CSS */
import "./DynamicTabs.scss"

const DynamicTabs = ({ tabs, activeIndex: controlledIndex, onTabChange, scrollable }) => {
  const [localIndex, setLocalIndex] = useState(0);

  const isControlled = controlledIndex !== undefined;
  const activeIndex = isControlled ? controlledIndex : localIndex;

  const handleChange = (e) => {
    isControlled ? onTabChange?.(e.index) : setLocalIndex(e.index);
  };

  return (
    <TabView activeIndex={activeIndex} onTabChange={handleChange} className={scrollable ? "scrollable-tabs" : ""}>
      {tabs.map((tab) => (
        <TabPanel key={tab.header} header={tab.header} leftIcon={tab.icon}>
          {tab.content}
        </TabPanel>
      ))}
    </TabView>
  );
};

DynamicTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
      icon: PropTypes.string,
    })
  ).isRequired,
  activeIndex: PropTypes.number,
  onTabChange: PropTypes.func,
  scrollable: PropTypes.bool,
};

export default DynamicTabs;
